<script lang="ts">
  // For more details: https://css-tricks.com/building-progress-ring-quickly/

  export let radius = 0;
  export let progress = 0;
  export let stroke = 0;
  export let rotate = '-rotate-90';
  let className = '';
  export { className as class };
  export let circleClasses = 'stroke-action-ondark-base transition-all';

  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;

  $: strokeDashoffset = circumference - (progress / 100) * circumference;
</script>

<svg height={radius * 2} width={radius * 2} class="shrink-0 {rotate} {className}">
  <circle class="stroke-neutral-500" r={normalizedRadius} stroke-width={stroke} cx={radius} cy={radius} fill="none" />
  <circle
    class={circleClasses}
    fill="transparent"
    stroke-linecap="round"
    stroke-dasharray={circumference + ' ' + circumference}
    style="stroke-dashoffset: {strokeDashoffset}"
    stroke-width={stroke}
    r={normalizedRadius}
    cx={radius}
    cy={radius}
  />
</svg>
